import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { useAccountFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { AccountFiltersProps } from './props';

export const AccountFilters = ({ onFilter, loading }: AccountFiltersProps) => {
    const { formik, typesDocument } = useAccountFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={typesDocument}
                    label="Tipo de documento"
                    name="typeDocument"
                    size="small"
                    touched={formik.touched.typeDocument}
                    errors={formik.errors.typeDocument}
                    value={formik.values.typeDocument as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre / Razón social"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Celular"
                    name="cellPhone"
                    size="small"
                    touched={formik.touched.cellPhone}
                    errors={formik.errors.cellPhone}
                    value={formik.values.cellPhone}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="E-mail"
                    name="email"
                    size="small"
                    touched={formik.touched.email}
                    errors={formik.errors.email}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación"
                    name="created_at"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.created_at}
                    errors={formik.errors.created_at?.toString()}
                    value={formik.values.created_at}
                    onChange={(value) =>
                        formik.setFieldValue('created_at', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
